// extracted by mini-css-extract-plugin
export default {"popoverContent":"orderMinimum_popoverContent__ztB7-","deliveryMinimumValue":"orderMinimum_deliveryMinimumValue__nyXgt"};